// Define the supported countries
const supportedBankAccountCountries = {
	AU: {
		routingNumber: {
			label: 'Bank state branch number',
			placeholder: '••••••',
			max: 6,
			min: 6,
			pattern: '[0-9]*',
		},
		accountNumber: {
			label: 'Account number',
			placeholder: '•••••••••',
			min: 5,
			max: 9,
		},
	},
	CA: {
		routingNumber: {
			label: 'Transit and institution number',
			placeholder: 'XXXXX-YYY',
			min: 8,
			max: 9,
			pattern: '[0-9]{8}|[0-9]{5}-[0-9]{3}',
		},
		accountNumber: {
			label: 'Account number',
			placeholder: '•••••••••',
			min: 7,
			max: 12,
			pattern: '[0-9]*',
		},
	},
	DE: {
		accountNumber: {
			label: 'International bank account number',
			placeholder: '••••••••••••••••••••••',
			min: 22,
			max: 22,
		},
	},
	ES: {
		accountNumber: {
			label: 'International bank account number',
			placeholder: '••••••••••••••••••••••••',
			min: 24,
			max: 24,
		},
	},
	GB: {
		routingNumber: {
			label: 'Sorting number',
			placeholder: '••-••-••',
			max: 8,
			min: 8,
			pattern: '[0-9]{2}-[0-9]{2}-[0-9]{2}',
		},
		accountNumber: {
			label: 'Account number',
			placeholder: '••••••••',
			min: 8,
			max: 8,
			pattern: '[0-9]*',
		},
	},
	MX: {
		accountNumber: {
			label: 'CLABE number',
			placeholder: '••••••••••••••••••',
			min: 18,
			max: 18,
			pattern: '[0-9]*',
		},
	},
	NZ: {
		accountNumber: {
			label: 'Account number',
			placeholder: '••••••••••••••••',
			min: 15,
			max: 16,
			pattern: '[0-9]*',
		},
	},
	SG: {
		routingNumber: {
			label: 'Bank and branch number',
			placeholder: 'XXXX-YYY',
			min: 8,
			max: 8,
			pattern: '[0-9]{4}-[0-9]{3}',
		},
		accountNumber: {
			label: 'Account number',
			placeholder: '•••••••••••••••••••',
			min: 6,
			max: 19,
			pattern: '[0-9]*',
		},
	},
	US: {
		routingNumber: {
			label: 'Routing number',
			placeholder: '•••••••••',
			max: 9,
			min: 9,
			pattern: '[0-9]*',
		},
		accountNumber: {
			label: 'Account number',
			placeholder: '•••••••••',
			min: 4,
			max: 17,
			pattern: '[0-9]*',
		},
	},
};

export default supportedBankAccountCountries;


// Typeguard for supported countries
export const isSupportedCountry = (key: string): key is keyof typeof supportedBankAccountCountries =>
	key in supportedBankAccountCountries;
